import { cn } from '@/lib/utils';

export function Card({ className, children, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('surface', className)} {...props}>
      {children}
    </div>
  );
}

export function CardHeader({ className, children }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('flex items-center justify-between px-4 py-3 border-b border-border', className)}>{children}</div>;
}

export function CardTitle({ className, children }: React.HTMLAttributes<HTMLSpanElement>) {
  return <span className={cn('text-sm font-semibold text-text-primary', className)}>{children}</span>;
}

export function CardBody({ className, children, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('p-4', className)} {...props}>{children}</div>;
}

export function StatCard({ label, value, sublabel, status, onClick }: {
  label: string;
  value: string | number;
  sublabel?: string;
  status?: 'online' | 'warning' | 'offline' | 'critical' | 'info';
  onClick?: () => void;
}) {
  const statusColor = status ? `var(--status-${status})` : 'var(--text-primary)';
  return (
    <div
      className={cn('surface p-4 flex flex-col gap-2', onClick && 'cursor-pointer hover:border-border-strong transition-colors')}
      onClick={onClick}
    >
      <span className="text-xs text-text-muted font-medium uppercase tracking-wide">{label}</span>
      <span className="text-2xl font-semibold tabular" style={{ color: statusColor }}>{value}</span>
      {sublabel && <span className="text-xs text-text-muted">{sublabel}</span>}
    </div>
  );
}
